module.exports = __webpack_public_path__ + "static/media/hervik-bjørn.da360aef.png";